import React, { createContext, useContext, useState, useCallback } from "react";

export type CmsLang = "th" | "en";

interface LanguageContextValue {
  currentLang: CmsLang;
  setCurrentLang: (lang: CmsLang) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  currentLang: "th",
  setCurrentLang: () => {},
});

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentLang, setLang] = useState<CmsLang>("th");

  const setCurrentLang = useCallback((lang: CmsLang) => {
    setLang(lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ currentLang, setCurrentLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

/** Helper: extract display text from multilingual or plain string */
export const getLocalizedText = (text: string | Record<string, string>, lang: CmsLang): string => {
  if (typeof text === "string") return text;
  return text[lang] || text["th"] || text["en"] || Object.values(text)[0] || "";
};
